import * as tslib_1 from "tslib";
import { Component, Prop, Watch } from "vue-property-decorator";
import { NumberFormatType } from "@cloudpivot/form/schema";
import { NumberInputControl } from "@cloudpivot/form/src/common/controls/input-controls/number-input-control";
// import { InputNumber } from "@h3/antd-vue";
import H3InputNumber from './h3-input-number.vue';
// import { InputNumber } from "@h3/antd-vue";
import numberFilter from "@cloudpivot/form/utils/number-filter";
let PcInputNumber = class PcInputNumber extends NumberInputControl {
    constructor() {
        super(...arguments);
        this.val = "";
        this.text = "";
        this.focused = false;
    }
    setControl() {
        const _ctrl = this.ctrl;
        // console.log('setControl', _ctrl.value)
        this.val = _ctrl.hasValue ? _ctrl.value : "";
        // if (_ctrl.hasValue) {
        this.formatNumber();
        // }
    }
    formatNumber() {
        if (!this.readonly) {
            if (!this.focused && this.$el) {
                const input = this.$el.querySelector("input");
                if (input) {
                    this.format(input);
                }
            }
        }
        else {
            this.text = this.formatter();
        }
    }
    handleValueChange(value) {
        const _ctrl = this.ctrl;
        this.$emit("change", _ctrl.value);
        this.val = _ctrl.hasValue ? _ctrl.value : null;
        this.formatNumber();
    }
    onValueChange(val) {
        if (val !== "" && val !== null) {
            val = Number(val);
        }
        if (typeof val === "number" && !Number.isNaN(val)) {
            // this.ctrl.value = val;
            this.setValue(this.typeTrans(val));
            this.val = this.typeTrans(val);
        }
        else {
            this.ctrl.value = null;
            this.val = "";
        }
    }
    onKeydown(evt) {
        const ft = this.controlOpts.format;
        if (ft === NumberFormatType.Int || ft === NumberFormatType.Ratio) {
            if (evt.key === ".") {
                evt.preventDefault();
            }
        }
    }
    onBlur(evt) {
        this.focused = false;
        const input = evt.target;
        this.format(input);
        this.$emit("blur");
    }
    onFocus(evt) {
        this.focused = true;
        setTimeout(() => {
            const input = evt.target;
            input.value = this.val;
        }, 100);
        this.$emit("focus");
    }
    format(input) {
        console.log('onFocus格式化前', this.val);
        const format = super.formatter();
        this.setValue(this.typeTrans(this.ctrl.value));
        // 设置500ms 兼容ie浏览器有时无法渲染格式化值问题
        setTimeout(() => {
            console.log('onFocus格式化后', format);
            return input.value = format;
        }, 500);
    }
    mounted() {
        this.doFormat();
    }
    doFormat() {
        if (typeof this.ctrl.value === "number") {
            const input = this.$el.querySelector("input");
            if (input) {
                this.format(input);
            }
        }
    }
    destroyed() {
        super.destroyed();
    }
    onWritableChange() {
        if (!this.ctrl.readonly) {
            this.$nextTick(() => {
                this.doFormat();
            });
        }
    }
};
tslib_1.__decorate([
    Prop({
        default: false
    })
], PcInputNumber.prototype, "mobile", void 0);
tslib_1.__decorate([
    Watch("val", {
        immediate: true
    })
], PcInputNumber.prototype, "onValueChange", null);
tslib_1.__decorate([
    Watch("readonly")
], PcInputNumber.prototype, "onWritableChange", null);
PcInputNumber = tslib_1.__decorate([
    Component({
        name: "input-number",
        components: {
            // AInputNumber: InputNumber
            H3InputNumber
        },
        filters: {
            number: numberFilter
        }
    })
], PcInputNumber);
export default PcInputNumber;
